<app-dialog
  id="show-secret"
  [hideFooter]="!profileUid"
  [title]="dialogTitle"
  (save)="updateAccountProfile()"
  [isValid]="isValid()"
>
  <section>
    <div class="row">
      <div class="col-4">
        {{ 'accountSettings.accountSetup.inventorySalesFeed.inventory.secret.hostname' | translate }}
      </div>
      <div class="col-8">
        <div class="row">
          <div class="col-8">
            <strong>{{ hostname }}</strong>
          </div>
          <div class="col-4">
            <mat-icon
              mat-button
              (click)="copyToClipboard(hostname)"
              [matTooltip]="'button.copyText' | translate"
              matTooltipPosition="after"
              >file_copy</mat-icon
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        {{ 'accountSettings.accountSetup.inventorySalesFeed.inventory.secret.username' | translate }}
      </div>
      <div class="col-8">
        <div class="row">
          <div class="col-8">
            <strong>{{ username }}</strong>
          </div>
          <div class="col-4">
            <mat-icon
              mat-button
              (click)="copyToClipboard(username)"
              [matTooltip]="'button.copyText' | translate"
              matTooltipPosition="after"
              >file_copy</mat-icon
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        {{ 'accountSettings.accountSetup.inventorySalesFeed.inventory.secret.password' | translate }}
      </div>
      <div class="col-8">
        <div class="row">
          <div class="col-8">
            <ng-container *ngIf="showPassword; else hidePassword">
              <strong>{{ password }}</strong>
            </ng-container>
            <ng-template #hidePassword>******</ng-template>
          </div>
          <div class="col-4 password">
            <mat-icon
              mat-button
              (click)="togglePasswordView()"
              [matTooltip]="'accountSettings.accountSetup.inventorySalesFeed.inventory.secret.showPassword' | translate"
              matTooltipPosition="after"
            >
              {{ !showPassword ? 'visibility' : 'visibility_off' }}
            </mat-icon>
            <mat-icon
              mat-button
              (click)="copyToClipboard(password)"
              [matTooltip]="'button.copyText' | translate"
              matTooltipPosition="after"
              >file_copy</mat-icon
            >
          </div>
        </div>
      </div>
    </div>
  </section>

  <ng-container *ngIf="!!profileUid">
    <section>
      <form id="update-inventory-profile" [formGroup]="formGroup">
        <div class="row">
          <div class="col">
            <mat-label class="d-flex">
              {{ 'accountSettings.accountSetup.inventorySalesFeed.inventory.dropdownLabel' | translate }}
            </mat-label>
            <mat-form-field appearance="outline">
              <mat-select disableOptionCentering formControlName="profile" (valueChange)="onProfileChange($event)" track="Account-Settings, secret_dialog_select_inventory_profile">
                <mat-option *ngFor="let importProfile of data.profiles" [value]="importProfile.uid">
                  {{ importProfile.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <ng-container *ngIf="selectedProfileIsShared">
              <mat-label>{{
                'accountSettings.accountSetup.inventorySalesFeed.inventory.sharedFeedTitle' | translate
              }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="sharedFeedId" track="Account-Settings, edit_shared_feed_id">
              </mat-form-field>
            </ng-container>
          </div>
        </div>
      </form>
    </section>
  </ng-container>
</app-dialog>
